<template>
  <div>
    <a-spin :spinning="globalSpining">
    <div>
      <a-avatar
        slot="avatar"
        :src="coverPath"
        style="margin-right: 10px"
      />
      <span style="font-weight: 700"> {{ currentGoodsName }}</span>
    </div>
    <a-divider></a-divider>
    <a-input ref="userNameInput" v-model="keyWords" placeholder="请输入商品名称或编号">
      <a-icon slot="prefix" type="filter"/>
    </a-input>
    <div style="height: 400px;overflow-y: auto">
      <a-list :data-source="filterGoods">
        <a-list-item slot="renderItem" slot-scope="item">
          <a slot="actions" @click="choiceGoods(item)">
            <span v-if="item.id !== currentValue">选中</span>
            <a-icon
              style="color: #2eb67d"
              v-if="item.id === currentValue"
              type="check"/>
          </a>
          <a-list-item-meta
            :description="item.description"
          >
            <a slot="title">{{ item.name }}</a>
            <a-avatar
              slot="avatar"
              :src="item.coverPath"/>
          </a-list-item-meta>
        </a-list-item>
      </a-list>
    </div>
    </a-spin>
  </div>
</template>

<script>
import { _queryWebsiteGoods } from '@/api/websiteGoodsApi';

export default {
  name: 'ImgWebsiteGoodsSelect',
  props: {
    type: String,
    value: String,
    status: String,
  },
  data() {
    return {
      form: {
        visible: false,
        data: {
          name: '',
        },
      },
      table: {
        data: [],
      },
      globalSpining: false,
      keyWords: '',
      options: [],
      currentValue: this.value,
      currentGoodsName: '',
      coverPath: '',
    };
  },
  watch: {
    currentValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.currentValue = val;
    },
  },
  computed: {
    filterGoods() {
      return this.options
        .filter(x => (this.keyWords
          ? (x.name.toUpperCase().includes(this.keyWords.toUpperCase()) ||
            x.code.toUpperCase().includes(this.keyWords.toUpperCase()))
          : true));
    },
  },
  methods: {
    choiceGoods(item) {
      this.$emit('input', item.id);
      this.currentGoodsName = item.name;
      this.coverPath = item.coverPath;
      this.form.visible = false;
    },
    openSearchForm() {
      this.form.visible = true;
      this.form.data.name = '';
    },
    onValueChange() {
    },
    async searchGoods() {
      this.globalSpining = true;
      if (this.form.data.name) {
        const result = await _queryWebsiteGoods({ name: this.form.data.name, status: 'IN_SELL' });
        this.table.data = result.content;
        this.globalSpining = false;
      }
    },
  },
  async created() {
    this.globalSpining = true;
    const result = await _queryWebsiteGoods({ name: this.form.data.name, status: 'IN_SELL' });
    this.globalSpining = false;
    this.options = result.content;
    const currentGoods = this.options.filter(x => x.id === this.value)[0];
    if (currentGoods) {
      this.currentGoodsName = currentGoods.name;
      this.coverPath = currentGoods.coverPath;
    }
  },
};
</script>

<style scoped>
.goods-wrap {
  height: 400px;
  overflow-y: auto;
}

.goods-item {
  margin: 10px 5px;
  cursor: pointer;
}

.goods-item:hover {
  color: #00A8CC;
}

</style>
